import { forwardRef, useState, useEffect, useRef } from 'react';

const resultClass = {
  G: 'animate-fade-green',
  Y: 'animate-fade-yellow',
  R: 'animate-fade-red',
};

const GameResource = forwardRef(({ value, onClick, result, disabled, possibilityCount, possibleResources, showLabel }, ref) => {
  const [showPossibilities, setShowPossibilities] = useState(false);
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (!showPossibilities) return;
    const handleClickOutside = (e) => {
      if (tooltipRef.current && !tooltipRef.current.contains(e.target)) {
        setShowPossibilities(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [showPossibilities]);

  const handleLabelClick = (e) => {
    e.stopPropagation();
    if (possibilityCount > 0) setShowPossibilities((prev) => !prev);
  };

  const hasLabel = showLabel && possibilityCount != null;

  return (
    <div className="flex flex-col items-center relative">
      { showLabel && (
        <span
          className={`h-4 md:h-5 text-[10px] md:text-xs font-bold select-none leading-4 md:leading-5 transition-colors ${hasLabel ? 'cursor-pointer text-primary-muted/70 hover:text-primary-muted' : 'text-transparent'}`}
          onClick={handleLabelClick}>
          {possibilityCount != null ? possibilityCount : '\u00A0'}
        </span>
      )}
      <div
        ref={ref}
        className={`
          flex items-center justify-center w-10 h-10 md:w-14 md:h-14 rounded-lg border transition-all duration-200 shadow-inner-light
          ${disabled ? 'cursor-default opacity-60' : 'cursor-pointer hover:border-white/20'}
          ${value && result ? `${resultClass[result] || ''} border-white/10` : 'bg-base-700/40 border-white/[0.06]'}
        `}
        onClick={onClick}>
          { value && <img
            src={`${process.env.PUBLIC_URL}/images/${value}.png`}
            alt={value}
            className="w-6 h-6 md:w-9 md:h-9 pointer-events-none"/> }
      </div>
      { showPossibilities && possibleResources && possibleResources.length > 0 && (
        <div ref={tooltipRef} className="absolute top-full left-1/2 -translate-x-1/2 mt-1.5 bg-base-800/95 backdrop-blur-sm border border-white/10 rounded-full px-2 py-1 flex gap-1 z-20 shadow-card whitespace-nowrap">
          {possibleResources.map((res) => (
            <div key={res} className="flex items-center justify-center w-6 h-6 md:w-7 md:h-7">
              <img src={`${process.env.PUBLIC_URL}/images/${res}.png`} alt={res} className="w-5 h-5 md:w-6 md:h-6" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
});

export default GameResource;
